export default __webpack_public_path__ + "static/media/36.90bd5c11.png";